import { render } from "./ListiniPage.vue?vue&type=template&id=06a784de"
import script from "./ListiniPage.vue?vue&type=script&lang=js"
export * from "./ListiniPage.vue?vue&type=script&lang=js"

import "@/css/StockPage.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__